import React from "react";
import type { ReactNode } from "react";
import PageNotFound from "../../ErrorPage";

interface Props {
  children: ReactNode;
}
interface State {
  error: unknown;
  errorInfo: unknown;
}
class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: unknown, errorInfo: unknown) {
    // prettier-ignore
    console.error('********** Error info from componentDidCatch in ErrorBoundary: ',error,errorInfo); /* NOSONAR */
  }

  static getDerivedStateFromError(error: unknown) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  clearError() {
    this.setState({ error: null, errorInfo: null });
  }

  render() {
    if (this.state.error) {
      return (
        <PageNotFound
          fromErrorBoundary
          clearError={this.clearError.bind(this)}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
